import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { cartPricing } from "@/lib/api";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fk_cart")) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("fk_cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.lookup_key === product.lookup_key);
      if (ex) return prev.map((i) => i.lookup_key === product.lookup_key ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, { ...product, quantity: 1, details: {} }];
    });
    setOpen(true);
  }, []);

  const updateDetail = useCallback((lookup_key, field, value) => {
    setItems((prev) => prev.map((i) => i.lookup_key === lookup_key
      ? { ...i, details: { ...(i.details || {}), [field]: value } } : i));
  }, []);

  const updateQty = useCallback((lookup_key, delta) => {
    setItems((prev) => prev
      .map((i) => i.lookup_key === lookup_key ? { ...i, quantity: Math.max(1, i.quantity + delta) } : i));
  }, []);

  const removeItem = useCallback((lookup_key) => {
    setItems((prev) => prev.filter((i) => i.lookup_key !== lookup_key));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((a, i) => a + i.quantity, 0);
  const total = cartPricing(items).total;

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, updateDetail, removeItem, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
